
import config from './config.js'
const st = {
  state: {
    home_main: {
      critical_asset_by_organization:{},
      spare_part_by_organization_ri:{},
      spare_part_by_organization_csp:{},
    }
  },
  getters: {
    home_main: state => state.home_main,
  },

  actions: {

  },
  mutations: {

  },
}
//agrega las st_key de config a el store
config
  .filter(c=>c.st_key)
  .forEach(c=>{
    st.state[c.st_key] = c.st_default || [];
    st.getters[c.st_key] = state => state[c.st_key];
  })
export default st;
